import { jsx } from "react/jsx-runtime";
import { Children, isValidElement, cloneElement } from "react";
import PropTypes from "prop-types";
import "@reach/auto-id";
import "lodash/fp";
import "styled-components";
import { useDisplayMode } from "../../hooks/use-display-mode.es.js";
import "../../utils/is-valid-ref.es.js";
import "../../contexts/display-mode-context/display-mode-context.es.js";
import "../../contexts/global-edit-context/global-edit-context.es.js";
import "../../contexts/toast-context/toast-context.es.js";
import "../../hooks/use-horizontal-scroll.es.js";
import "react-use-measure";
import "@juggle/resize-observer";
import "@reach/utils";
import "@reach/rect";
import "compute-scroll-into-view";
import { Secondary } from "../secondary/secondary.es.js";
import { Strong } from "../strong/strong.es.js";
import { TextImpl } from "./text.styles.es.js";
const propTypes = {
  children: PropTypes.node.isRequired,
  displayMode: PropTypes.oneOf(["light", "dark"]),
  maxLines: PropTypes.number,
  size: PropTypes.oneOf(["medium", "large"]),
  tone: PropTypes.oneOf(["critical", "neutral", "positive", "secondary"])
};
const defaultProps = {
  displayMode: void 0,
  maxLines: void 0,
  size: "medium",
  tone: "neutral"
};
const Text = ({
  children,
  displayMode: displayModeProp,
  maxLines,
  size,
  tone
}) => {
  const displayMode = useDisplayMode(displayModeProp);
  return /* @__PURE__ */ jsx(
    TextImpl,
    {
      $displayMode: displayMode,
      $maxLines: maxLines,
      $size: size,
      $tone: tone,
      children: Children.map(
        children,
        (child) => isValidElement(child) && (child.type === Secondary || child.type === Strong) ? cloneElement(child, { displayMode }) : child
      )
    }
  );
};
Text.propTypes = propTypes;
Text.defaultProps = defaultProps;
export {
  Text
};
